module.exports = __webpack_public_path__ + "img/logo-vlf.370738b.png";